/*
 * @Description: 
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2021-12-08 21:46:17
 * @LastEditors: sen.yang
 * @LastEditTime: 2021-12-22 14:50:12
 */
import request from '../../utils/request'
import server from './config'
import common from '../../utils/common'
export default {
    /**
     * 上传数据
     */
    wxPay:(responseData)=>{
        return new Promise((resolve, reject) => {
          common.weixinPay(responseData, function(data){
              WeixinJSBridge.invoke(
                "getBrandWCPayRequest",
                {
                  appId: data.appId, //公众号名称，由商户传入
                  timeStamp: data.timeStamp, //时间戳，自1970年以来的秒数
                  nonceStr: data.nonceStr, //随机串
                  package: data.packageValue,
                  signType: data.signType, //微信签名方式：
                  paySign: data.paySign //微信签名
                },
                function(res) {
                  resolve(res)
                }
              );
            });
          })
    },
}


// WEBPACK FOOTER //
// ./src/api/modules/pay.js